<template>
  <RF-Dialog v-show="mostrar === true"
    :cpntStatus='statusGeral'
    :cpntLargura='"850px"'
    :cpntTitulo='"Selecione abaixo como deseja anexar um arquivo!"'

    :cpntOnFecharDialog='armArquivoAnexarFechar'>
    <template slot="conteudo">
      <table class="arm-arq-anexar">
        <tr>
          <td v-for="option in tiposOpcoes" :key="option.chave" class="noselect arm-arq-anexar-tipos" :style="'width: calc(100% / ' + tiposOpcoes.length + ');'">
            <RF-Radio class="rf-checkbox" :data-time="time"
              :cpntStatus='option.status'

              :cpntId='option.id + "--" + option.chave'
              :cpntName='option.id + "-tipo-pag"'
              :cpntValue='option.chave'
              :cpntNome='option.nome'
              :cpntModel='tiposValor'

              :cpntOnChange='armArquivoAnexarOnChangeTipo'
            ></RF-Radio>
          </td>
        </tr>
        <tr>
          <td :colspan="tiposOpcoes.length" class="arm-arq-anexar-valor" :class="'arm-arq-anexar-valor-' + tiposValor">
            <div v-if="[ 9 ].indexOf(cpntRefMod) !== -1" class="financeiro">
              <!-- TITULO -->
              <div class="titulo">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                Detalhes do registro
              </div>

              <!-- REGISTRO FINANCEIRO -->
              <!-- <RF-Financeiro-Relatorio  :data-time='time' 
                :cpntTabelaResumida="false"
                :cpntRegTp="cpntRegTp"
                :cpntRemoverColuna="[ 'fraseTop', 'arm-arquivos', 'rf-pgto', 'dt_cad_ptbr', 'rf-log' ]"
                :cpntFiltroTabela="{ aAnd: [ { f: 'id', o: 'in', v: cpntRefId } ] }"
              ></RF-Financeiro-Relatorio> -->

              <App-Financeiro-Relatorios
              :cpntDemanda='"financeiro"'
              :cpntDemandaId="cpntRefId"
              :cpntRemoverColunas="[ 'titulo', 'arm_arquivos', 'id_pgto_nome', 'dt_cad_ptbr', 'log' ]"
              ></App-Financeiro-Relatorios>
            </div>

            <div class="anexar">
              <!-- TITULO -->
              <div class="titulo">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                Anexar arquivos
              </div>

              <!-- APRESENTA A OPÇÃO DO QRCODE -->
              <template v-if="tiposValor === 'qrcode'">
                <table v-if="[ '', null, undefined ].indexOf(seletor.qrcode) === -1" >
                  <tr>
                    <td>
                      <b style="font-style: italic;">Como usar um leitor de QR Code</b>
                      <div style="padding-left: 10px; text-align: justify;">
                        A maioria dos dispositivos Android, iOS e outros disponíveis hoje possuem a capacidade de ler um QR Code com o  proprio app de câmera nativo.
                        <br/><br/>
                        Se você possui um iPhone, é necessario fazer alguns ajustes primeiro:
                        <div style="padding-left: 10px;">
                          1 - Abra o app Ajustes;<br/>
                          2 - Toque em “Câmera”;<br/>
                          3 - Ligue a chave “Escanear Códigos QR”.
                        </div>
                        <br/>
                        Caso seu dispositivo não consiga ler o QR Code com o app câmera.
                        <div style="padding-left: 10px;">
                          Procure na loja de aplicativos do seu disponivito por, "Leitor QR Code", e você terá varias opções disponiveis.
                        </div>
                        <br/>
                        Com todos os ajustes feitos, basta abrir o app Câmera e apontar o seu dispositivo para o QR Code;
                        <!-- <br/><br/> -->
                      </div>
                    </td>
                    <td style="vertical-align: top; padding-left: 25px; width: 195px;">
                      <qrcode-vue :size='"170"' :value="seletor.qrcode" level="H"></qrcode-vue>
                    </td>
                  </tr>
                </table>
              </template>

              <!-- APRESENTA O SELECTOR E O DROP -->
              <div v-else class="drop">
                <div v-if="Object.keys(seletor).length >= 1" ref="drop_area" class="noselect" :class="seletor.class">
                  <span v-show="envio === null">
                    <input :id='seletor.id + "-input"' name="files[]" :disabled="seletor.disabled" :multiple="cpntMultiplosArquivos" type="file" @change="seletor.onChange"/>
                    <label :for='seletor.id + "-input"'><strong>Escolha um arquivo</strong><span> ou arraste-o aqui</span>.</label>
                  </span>

                  <RF-Progress-Upload-Donwload v-if="envio !== null"
                    :cpntMensagem="envio.mensagem"
                    :cpntTotal="envio.total"
                    :cpntTransferido="envio.transferido"
                    :cpntHeight="'30px'"
                  ></RF-Progress-Upload-Donwload>
                </div>
              </div>
            </div>

            <div class="arquivos" v-if="[ 7, 9 ].indexOf(cpntRefMod) !== -1">
              <!-- TITULO -->
              <div class="titulo">
                <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
                Anexados
              </div>

              <!-- ARQUIVOS SALVOS -->
              <div class="files" v-if="[ '', null, undefined ].indexOf(files) === -1 && Object.keys(files).length >= 1" :key="timeRecebe">
                <template v-for="(a, index) in files">
                  <Armazenamento-Arquivos-Icone v-if="[ '', null, undefined ].indexOf(files[index].time) === -1" :key="'div-' + files[index].time + '-' + files[index].id" 
                    :cpntId='files[index].id'
                    :cpntFileName='files[index].filename'
                    :cpntFileExt='files[index].ext'
                    :cpntFileSizeThumbnail='files[index].size_bytes_thumbnail'
                    :cpntThumbnail='files[index].thumbnail_b64'
                    :cpntDeleteArquivo='armArquivoAnexarApagarArquivo'
                    :cpntCopiarArquivo="cpntRefMod === 7 ? armArquivoAnexarCopiarArquivo : null"
                  ></Armazenamento-Arquivos-Icone>
                </template>
              </div>
              <div v-else>
                Nenhum anexo encontrado.
              </div>
            </div>            
          </td>
        </tr>
      </table>
    </template>
  </RF-Dialog>
</template>

<style scoped>
.arm-arq-anexar {
  /* width: calc(100% + 20px + 20px); */
  width: calc(100% + 20px + 10px);
  margin-top: -10px;
  margin-left: -25px;
}
  .arm-arq-anexar > tr > .arm-arq-anexar-tipos {
    text-align: center;
    padding: 20px 10px 10px 10px;
    border-bottom: 1px solid #ccc;
    background: #f9f9f9;
  }
  .arm-arq-anexar > tr > .arm-arq-anexar-valor {
    padding: 25px 10px 0px 10px;
  }
    
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.anexar > div.drop {
      max-height: 250px;
      min-height: 250px;
    }
    .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop {
      width: 600px;
      height: 200px;
      margin: 0px auto;
    }
      .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload {
        width: 600px;
        height: 200px;
        display: table-cell;
        vertical-align: middle;
        border-radius: 5px;

        outline: 2px dashed #92b0b3;
        outline-offset: -10px;
        -webkit-transition: outline-offset .15s ease-in-out, background-color .15s linear;
        transition: outline-offset .15s ease-in-out, background-color .15s linear;
        transition: all 0.3s ease-in-out;

        background-color: #c8dadf;
        padding: 30px 20px;
        text-align: center;
      }
        .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload > span > input {
          width: 0.1px;
          height: 0.1px;
          opacity: 0;
          overflow: hidden;
          position: absolute;
          z-index: -1;
        }
          .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload > span > label {
            cursor: pointer;
            color: #0f3c4b;
            font-size: var(--font-base-soma-15);
          }
          .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload > span > input:disabled ~ label {
            cursor: no-drop;
          }
          .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload > span > label:hover strong {
            color: #39bfd3;
            font-weight: bold;
          }
      .arm-arq-anexar > tr > .arm-arq-anexar-valor-seleciona > div.anexar > div.drop > .arm-arq-box-upload > span-dragover {
        outline-offset: -20px;
        outline-color: #c8dadf;
        background-color: #f9f9f9;
      }

    .arm-arq-anexar > tr > .arm-arq-anexar-valor-qrcode > div {
      padding: 0px 20px;
      margin: 0px auto;
    }

    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.financeiro {
      width: calc(100% + 10px);
      padding: 0px 15px 10px 20px;
      margin-top: -20px;
      border-bottom: 1px solid #ccc;
    }
      .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.financeiro > .titulo {
        margin-bottom: 5px;
      }
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.arquivos {
      width: calc(100% + 10px);
      padding: 5px 15px 10px 20px;
      text-align: center;
      margin-top: -10px;
    }
    
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.anexar {
      width: calc(100% + 10px);
      padding: 5px 15px 5px 20px;
      text-align: center;
      border-bottom: 1px solid #ccc;
      margin-bottom: 10px;
    }
      .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.anexar > .titulo {
        margin-bottom: 5px;
      }
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.anexar > .titulo,
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.financeiro > .titulo,
    .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.arquivos > .titulo {
      text-align: left;
      font-weight: bold;
      font-style: italic;
      opacity: 0.85;
    }
    
</style>

<style>
  .arm-arq-anexar > tr > .arm-arq-anexar-valor > div.arquivos > .files > .cpnt-arm-arq-icone {
    padding: 0px;
    margin: 0px;
  }
</style>

<script>
export default {
  props: {
    cpntRefId: {
      required: true,
      type: String
    },
    cpntRefMod: {
      required: true,
      type: Number
    },
    cpntRegTp: {
      required: false
    },
    cpntSalvarPosteriormente: {
      required: false,
      default: function () {
        return null
      }
    },
    cpntMultiplosArquivos: {
      required: false,
      type: Boolean,
      default: function () {
        return true
      }
    },
    cpntValorInicial: {
      required: false,
      type: String,
      default: function () {
        return 'seleciona'
      }
    },
    cpntFecharFormulario: {
      required: false,
      default: function () {
        return null
      }
    }
  },
  components: {
    'App-Financeiro-Relatorios': () => import('@/components/financeiro/Relatorio/Financeiro-Relatorios.vue'),

    'qrcode-vue': () => import('qrcode.vue'),
    'RF-Radio': () => import('@/components/rf-geral/radio/RF-Radio.vue'),
    'RF-Progress-Upload-Donwload': () => import('@/components/rf-geral/progress/RF-Progress-Upload-Donwload.vue'),
    'Armazenamento-Arquivos-Icone': () => import('@/components/armazenamento-arquivos/Armazenamento-Arquivos-Icone.vue')
  },
  data: function () {
    return {
      time: '',
      timeRecebe: '',
      statusGeral: 'carregando',
      tiposOpcoes: [],
      tiposValor: '',
      mostrar: true,
      seletor: {},
      arquivos: [],
      files: {},
      envio: null
    }
  },
  mounted: function () {
    this.armArquivoAnexarIniciar()
  },
  methods: {
    armArquivoAnexarIniciar: function () {
      // CHAMA A FUNÇÃO PARA SETAR O STATUS
      this.armArquivoAnexarSetarStatusGeral('carregando')

      // SETA OS TIPOS DISPONIVEIS PARA ANEXAR
      this.tiposOpcoes = [
        { chave: 'seleciona', id: 'arm-arq-anexar-tipos', nome: 'Selecionar arquivo' }
      ]

      // VERIFICA SE DEVE ATIVAR A OPÇÃO POR UPLOAD VIA QRCODE
      if ([ '', null, undefined, '0', 0 ].indexOf(this.cpntRefId) === -1) {
        this.tiposOpcoes.push({ chave: 'qrcode', id: 'arm-arq-anexar-tipos', nome: 'QR Code' })
      }

      // INICIA O SELETOR
      this.seletor = {
        id: 'arm-arq-anexar-tipos',
        class: 'arm-arq-box-upload',
        value: '',
        qrcode: '',
        disabled: false,
        onChange: this.armArquivoAnexarOnChangeInput
      }

      // SETA O VALOR INICIAL RECEBIDO
      this.armArquivoAnexarOnChangeTipo(this.cpntValorInicial)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // VERIFICA SE DEVE MOSTRAR OS ARQUIVOS
      if ([ 7, 9 ].indexOf(this.cpntRefMod) !== -1) {
        // ADICIONA O OBSERVADOR
        this.$store.state.WEB_SOCKET_OBSERVADOR('ArmArquivo', 'recebe-arq-anexar', this.armArquivoAnexarReceberArquivo, 'usu')

        // CHAMA A FUNÇÃO PARA CARREGAR OS ARQUIVOS
        this.armArquivoAnexarBuscarArquivo(() => { this.armArquivoAnexarSetarStatusGeral('') })
      } else {
        this.armArquivoAnexarSetarStatusGeral('')
      }
    },
    armArquivoAnexarFechar: function (atualizar, ids = []) {
      // CONVERTE O VALORE RECEBIDO
      if ([ '', null, undefined ].indexOf(ids) !== -1) {
        ids = []
      } else if (typeof ids === 'string') {
        ids = [ ids ]
      }

      // CHAMA A FUNÇÃO PARA FECHAR O CARREGAMENTO
      if ([ '', null, undefined ].indexOf(this.cpntFecharFormulario) === -1) {
        this.cpntFecharFormulario(atualizar, ids)
      }
    },
    armArquivoAnexarSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoAnexarOnChangeTipo: function (valor) {
      // SETA O VALOR INICIAL RECEBIDO
      this.tiposValor = valor

      // VERIFICCA AS AÇÕES QUE DEVE REALIZAR
      switch (this.tiposValor) {
        case 'seleciona':
          // LIMPA OS DADOS DO INPUT
          this.seletor.value = ''

          // CHAMA A FUNÇÃO PARA INICIAR OS OBSERVADORES
          this.armArquivoAnexarSeletorObservadorIniciar(this)

          // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
          this.armArquivoAnexarVerificarStatusSeletor()
          break

        case 'qrcode':
          // // CHAMA A FUNÇÃO PARA FINALIZAR OS OBSERVADORES
          // this.armArquivoAnexarSeletorObservadorFinalizar()

          // LIMPA OS DADOS DO INPUT
          this.seletor.qrcode = ''

          // CHAMA A FUNÇÃO PARA GERAR O LINK
          this.armArquivoAnexarGerarQRCode()
          break

        default:
          // // CHAMA A FUNÇÃO PARA FINALIZAR OS OBSERVADORES
          // this.armArquivoAnexarSeletorObservadorFinalizar()
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoAnexarSeletorObservadorIniciar: function (self, tentativa = 0) {
      if (tentativa <= 10) {
        setTimeout(function () {
          if ([ '', null, undefined ].indexOf(self.$refs) !== -1 || [ '', null, undefined ].indexOf(self.$refs.drop_area) !== -1) {
            self.armArquivoAnexarSeletorObservadorIniciar(self, (tentativa + 1))
          } else {
            var funcao = function (force = false, requestId = '') {
              if (force === true || self.seletor.requestId === requestId) {
                // SETA A CLASSE DO CAMPO
                self.seletor.class = [ 'arm-arq-box-upload' ]

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }
            }

            // ADICIONA O EVENTO AO COLOCAR UM ARQUIVO SOBRE O CAMPO
            $(self.$refs.drop_area).on('dragover', function (event) {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // SETA O REQUEST ID
              var flag = Math.floor(Math.random() * (9999 - 1000)) + 1000

              // SETA O ID GERADO
              self.seletor.requestId = flag

              // SETA A CLASSE DO CAMPO
              self.seletor.class = [ 'arm-arq-box-upload', 'arm-arq-box-upload-dragover' ]

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS APÓS 200MS
              setTimeout(function () { funcao(false, flag) }, 200)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(self.$refs.drop_area).on('dragenter', function () {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // CHAMA A FUNÇÃO PARA LIMPAR O STATUS
              funcao(true)
            })

            // ADICIONA O EVENTO AO TIRAR UM ARQUIVO SOBRE O CAMPO
            $(self.$refs.drop_area).on('drop', function (event) {
              // PARA A AÇÃO DO EVENTO
              event.stopPropagation()
              event.preventDefault()

              // DESABILITA O INPUT PARA INSERIR NOVO
              self.seletor.disabled = true

              // LIMPA O STATUS PARA PARAR O PROCESSO
              self.seletor.requestId = ''

              // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
              self.seletor.value = []

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()

              // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
              self.armArquivoAnexarArquivoLer(event.originalEvent.dataTransfer.files)

              // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
              self.armArquivoAnexarVerificarStatusSeletor()
            })
          }
        }, tentativa === 0 ? 1 : 200)
      }
    },
    // armArquivoAnexarSeletorObservadorFinalizar: function () {
    // },
    armArquivoAnexarVerificarStatusSeletor: function () {
      // VERIFICA SE TEM ALGUM ARQUIVO SELECIONADO
      this.seletor.disabled = ([ '', null, undefined ].indexOf(this.seletor.value) === -1 || this.seletor.value.length >= 1)
      
      // VERIFICA O STATUS DO CAMPO
      switch (this.seletor.disabled) {
        case true:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'arm-arq-box-upload', 'arm-arq-box-upload-dragover' ]
          break

        case false:
          // SETA A CLASSE DO CAMPO
          this.seletor.class = [ 'arm-arq-box-upload' ]
          break
      }

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoAnexarOnChangeInput: function (event) {
      // LIMPA OS DADOS DO INPUT
      this.seletor.value = ''

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()

      // PEGA O ARQUIVO
      var arquivo = [ '', null, undefined ].indexOf(event.clipboardData) === -1 ? event.clipboardData : event.target

      // VERIFICA SE TEM ALGUM ARQUIVO PARA SALVAR
      if (arquivo.files.length >= 1) {
        // DESABILITA O INPUT PARA INSERIR NOVO
        this.seletor.disabled = true

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA SALVAR OS ARQUIOS
        this.armArquivoAnexarArquivoLer(arquivo.files)
      }

      // CHAMA A FUNÇÃO PARA VERIFICA OS DADOS DO SELETOR
      this.armArquivoAnexarVerificarStatusSeletor()
    },
    armArquivoAnexarProgress: function (mensagem, retornos) {
      // INICIA A VARIAVEL QUE VAI RECEBER OS DADOS
      var dados = { total: 0, transferido: 0 }

      // PEGA OS DADOS RECEBIDOS
      if ([ '', null, undefined ].indexOf(retornos.result) === -1) {
        dados = retornos.result
      }

      // ALTERA A MENSAGEM DO CAMPO
      dados.mensagem = mensagem

      // SETA OS DADOS RECEBIDOS DA PARCIAL
      this.envio = dados

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    armArquivoAnexarArquivoLer: function (files, salvar = false, refId = null, callback = null) {
      if (files !== null) {
        // SETA OS ARQUIVOS RECEBIDOS
        for (var key in files) {
          if ([ '', null, undefined ].indexOf(files[key].name) === -1 && [ '', null, undefined ].indexOf(files[key].size) === -1) {
            this.arquivos[this.arquivos.length] = files[key]
          }
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE DEVE FECHAR OU NÃO O FORMULARIO
        if (([ '', null, undefined ].indexOf(this.cpntSalvarPosteriormente) === -1 && typeof this.cpntSalvarPosteriormente === 'function' && salvar === false)) {
          this.armArquivoAnexarLerArquivo(files)
        } else {
          this.armArquivoAnexarArquivoLer(null, true, refId, callback)
        }
      } else if (salvar === true && this.arquivos.length >= 1) {
        // OCULTA DE ARMAZENAMENTO
        this.mostrar = true

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // VERIFICA SE FOI RECEBIDO UM NOVO ID PARA SALVAR
        if ([ '', null, undefined ].indexOf(refId) !== -1) {
          refId = this.cpntRefId
        }

        // IMPORA A FUNÇÃO PARA ATUALIZAÇÃO
        const ARMAZENAR_ARQUIVO_S3 = require('@/assets/js/Armazenar-Arquivos.js').ARMAZENAR_ARQUIVO_S3
  
        // CHAMA A FUNÇÃO PARA ENVIAR O ARQUIVO
        ARMAZENAR_ARQUIVO_S3(this.arquivos, Number(this.cpntRefMod), Number(refId), this.armArquivoAnexarProgress).then((retorno) => {
          // TRATA A MENSAGEM RECEBIDA
          this.$store.state.TRATAR_RET_LOT_API({ lot: retorno }, null, 'API [200]: Arquivo(s) enviado(s) com sucesso.')  
  
          // LIMPA OS ARQUIVOS DO VETOR
          this.seletor.value = ''

          // LIMPA O VETOR DE ARQUIVOS
          this.arquivos = []

          // EXECUTA A FUNÇÃO CALLBACK SOLICITADA
          if (callback !== null) {
            callback()
          }
  
          // CHAMA A FUNÇÃO PARA FECHAR E ATUALIZAR OS DADOS ATRAS
          if ([ 7, 9 ].indexOf(this.cpntRefMod) === -1) {
            this.armArquivoAnexarFechar(true)
          } else {
            // DESABILITA O INPUT PARA INSERIR NOVO
            this.seletor.disabled = false

            // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
            this.seletor.value = []

            // LIMPA O VALOR
            this.envio = null

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        }).catch(this.armArquivoAnexarSetarStatusGeral)
      }
    },
    armArquivoAnexarLerArquivo: function (files, index = 0, vetor = []) {
      if ([ '', null, undefined ].indexOf(files[index]) !== -1) {
        // OCULTA DE ARMAZENAMENTO
        this.mostrar = false

        // DESABILITA O INPUT PARA INSERIR NOVO
        this.seletor.disabled = false

        // INICIAR O INPUT QUE RECEBE OS ARQUIVOS
        this.seletor.value = []

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // PASSA OS ARQUIVOS E O PARAMETRO DO COMPONENT PARA ATUALIZAR DEPOIS
        this.cpntSalvarPosteriormente(vetor, this)
      } else {
        // INICIA O VETOR
        vetor[index] = {}

        // SETA O ID DO ARQUIVO
        vetor[index].id = ''

        // SETA A EXTENSAO DO ARQUIVO
        vetor[index].ext = files[index].name.match(/\.[0-9a-z]+$/i)

        // SETA A EXTENSÃO DO ARQUIVO ENCONTRADA
        vetor[index].ext = vetor[index].ext.length === 1 ? vetor[index].ext[0].substring(1, vetor[index].ext[0].length) : vetor[index].ext[0]

        // CONVERTE A STRING PARA MINUSCULA
        vetor[index].ext = vetor[index].ext.toLowerCase()

        // SETA O NOME DO ARQUIVO
        vetor[index].name = files[index].name

        // VERIFICA O TIPO DE ARQUIVO
        switch (vetor[index].ext) {
          // SETA SE TEM ICONE DE IMAGEM
          case 'png':
          case 'jpg':
          case 'jpeg':
          case 'gif':
            vetor[index].size_bytes_thumbnail = Number(files[index].size)
            break

          // SETA QUE NÃO É UMA IMAGEM
          default:
            vetor[index].size_bytes_thumbnail = 0
            break
        }

        // INICIA A LEITURA DO ARQUIVO
        var reader = new FileReader()

        // SETA FUNÇÃO DE SUCESSO DE LEITURA
        reader.onload = () => {
          // INICIA A VARIAVEL
          var tagB64 = ''

          // VERIFICA SE DEVE COLOCAR OS DADOS DE BASE64 NO LINK
          if (vetor[index].size_bytes_thumbnail > 0) {
            tagB64 = 'data:image/' + vetor[index].ext + ';base64, '
          }

          // SETA A IMAGEM RECEBIDA
          vetor[index].thumbnail = tagB64 + (vetor[index].size_bytes_thumbnail === 0 ? '' : window.btoa(reader.result))
          vetor[index].conteudo = tagB64 + (window.btoa(reader.result))

          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          this.armArquivoAnexarLerArquivo(files, (index + 1), vetor)
        }

        // FAZ A LEITURA DO ARQUIVO RECEBIDO
        reader.readAsBinaryString(files[index])
      }
    },
    armArquivoAnexarGerarQRCode: function () {
      var self = this

      var formData = { refMod: this.cpntRefMod, refId: this.cpntRefId }

      // SETA O ID DO USUARIO
      formData.clu = Number(self.$store.state.token.clu)

      // SETA O ID DO USUARIO
      formData.id_usu = Number(self.$store.state.token.clu_iu)

      // SETA O ID DO USUARIO
      formData.conta = self.$store.state.token.conta

      // SETA O ID DO USUARIO
      formData.token = self.$store.state.token.token

      // CONVERTE O FORMULARIO QUE SERÁ ENVIADO
      formData = { j_conteudo: JSON.stringify(formData) }

      // FAZ A COMUNICAÇÃO COM A API
      self.$store.state.comunicaAPI('/subase/qrcode', 'POST', formData, function (apiSuccess) {
        switch([ '', null, undefined ].indexOf(apiSuccess.qrcode) !== -1) {
          case true:
            self.armArquivoAnexarSetarStatusGeral({ loc: 'WEB', cod: 500, err: 'Erro ao gerar link do QRCode.' })
            break

          case false:
            // LIMPA OS DADOS DO INPUT
            self.seletor.qrcode = process.env.VUE_APP_URL_WEB + '/uploads-qrcode/' + apiSuccess.qrcode

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
            break
        }
      }, self.armArquivoAnexarSetarStatusGeral)
    },
    armArquivoAnexarSalvarArquivos: function () {
      if ([ '', null, undefined ].indexOf(this.seletor.value) === -1 && this.seletor.value.length >= 1) {
        var self = this

        // INICIA O VETOR QUE SERÁ ENVIADO PARA API
        var formData = []
        var registro = {}

        // VERIFICA O TIPO DO REGISTRO
        switch (self.cpntRefMod) {
          case 7:
            registro.id_ema_mar_layout = self.cpntRefId
            break

          case 9:
            registro.id_financeiro = self.cpntRefId
            break

          case 10:
            registro.id_pro_imagem = self.cpntRefId
            break

          case 12:
            registro.cod_venda = self.cpntRefId
            break

          case 31:
            registro.id_doc_fis_distribuir = self.cpntRefId
            break

          case 53:
            registro.id_reg_atendimento = self.cpntRefId
            break
        }

        // ADICIONA TODOS OS ARQUIVOS EXISTENTES
        for (var key in this.seletor.value) {
          formData.push(Object.assign(self.seletor.value[key], registro))
        }
        
        // CONVERTE O REGISTRO EM LOT
        formData = { lot: formData }

        // FAZ A COMUNICAÇÃO COM A API
        self.$store.state.comunicaAPI('/arm-arquivo', 'POST', formData, function (apiSuccess) {
          // TRATA A MENSAGEM RECEBIDA
          self.$store.state.TRATAR_RET_LOT_API(apiSuccess, null, 'API [200]: Arquivo(s) enviado(s) com sucesso.')  

          // LIMPA OS ARQUIVOS DO VETOR
          self.seletor.value = ''

          // INICIA O VETOR PARA ADICIONAR OS IDS
          var arquivosIds = []

          // ADICIONA OS ARQUIVOS RECEBIDOS
          for (var index in apiSuccess.lot) {
            if (apiSuccess.lot[index].code === '200' && [ '', null, undefined ].indexOf(apiSuccess.lot[index].ref) === -1 && [ '', null, undefined ].indexOf(apiSuccess.lot[index].ref.id) === -1) {
              arquivosIds.push(apiSuccess.lot[index].ref.id)
            }
          }

          // CHAMA A FUNÇÃO PARA FECHAR E ATUALIZAR OS DADOS ATRAS
          self.armArquivoAnexarFechar(true, arquivosIds)
        }, self.armArquivoAnexarSetarStatusGeral)
      }
    },
    armArquivoAnexarBuscarArquivo: function (callback = null) {
      // INICIA O QUERY GET
      var queryGet = { type: 'list', limit: { row: 0, qty: 1000 }, where: { aAnd: [ { f: 'status', o: '=', v: '1' } ] } }

      // VERIFICA O TIPO DO REGISTRO
      switch (this.cpntRefMod) {
        case 7:
          // queryGet.where.aAnd.push({ f: 'id_ema_mar_layout', o: '=', v: this.cpntRefId })
          queryGet.where.aAnd.push({ f: 'acl', o: '=', v: 'public-read' })
          break
          
        case 9:
          queryGet.where.aAnd.push({ f: 'id_financeiro', o: '=', v: this.cpntRefId })
          break
        
        case 10:
          queryGet.where.aAnd.push({ f: 'cod_venda', o: '=', v: this.cpntRefId })
          break

        case 12:
          queryGet.where.aAnd.push({ f: 'id_pro_imagem', o: '=', v: this.cpntRefId })
          break       

        case 31:
          queryGet.where.aAnd.push({ f: 'id_doc_fis_distribuir', o: '=', v: this.cpntRefId })
          break
        
        case 53:
          queryGet.where.aAnd.push({ f: 'id_reg_atendimento', o: '=', v: this.cpntRefId })
          break
      }

      // CHAMA FUNÇÃO PARA COMUNICAR COM API
      this.$store.state.comunicaAPI('/arm-arquivo/get/', 'GET', queryGet, (apiSuccess) => {        
        // INICIA A VARIAVEL PARA SETAR OS IDS
        var thumbnailIds = []

        // VERIFICA QUAIS SÃO OS ARQUIVOS QUE DEVE BUSCAR O ICONE
        for (var key in apiSuccess.data) {
          // INICIA A VARIAVEL DO ICONE DO ARQUIVO
          apiSuccess.data[key].time = 1
          apiSuccess.data[key].thumbnail_b64 = ''

          // INICIA O VETOR
          this.files[apiSuccess.data[key].id] = apiSuccess.data[key]

          // ADICIONA O ID
          if ([ '', null, undefined ].indexOf(apiSuccess.data[key].size_bytes_thumbnail) === -1 && Number(apiSuccess.data[key].size_bytes_thumbnail) > 0) {
            thumbnailIds.push(apiSuccess.data[key].id)
          }
        }

        // CHAMA A FUNÇÃO PARA BUSCAR OS ICONES
        this.armArquivosRecebeQrCodeBuscarThumbnail('thumbnail_b64', thumbnailIds, (registros) => {
          // SETA OS ICONES RECEBIDOS
          for (var key in registros) {
            // SETA O ICONE
            this.files[registros[key].id].thumbnail_b64 = registros[key].thumbnail_b64

            // SETA O TIME PARA ATUALIZAR
            this.files[registros[key].id].time = new Date().getTime()
          }

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // EXECUTA O CALLBACK RECEBIDO
          if (callback !== null) {
            callback()
          }
        })
      }, this.armArquivoAnexarSetarStatusGeral)
    },
    armArquivosRecebeQrCodeBuscarThumbnail: function (tipo, ids, callback, qtde = 300, ini = null, fim = null, retornos = []) {
      // SETA OS DADOS QUE SERÁ BUSCADO
      if (ini === null && fim === null) {
        ini = 0
        fim = qtde
      } else if (ids.length > (ini + qtde)) {
        ini += qtde
        fim += qtde
      } else {
        ini = null
        fim = null
      }

      if (ini !== null && fim !== null && ids.length >= 1) {
        // PEGA OS IDS QUE DEVE BUSCAR
        var busca = ids.slice(ini, fim)

        // INICIA O QUERYGET
        var queryGet = { lot: [] }
        
        // ADICIONA O VALOR AO VETOR
        for (var key in busca) {
          queryGet.lot.push({ id: busca[key], tipo: [ tipo ] })
        }

        // FAZ A BUSCA NA API
        this.$store.state.comunicaAPI('/arm-arquivo/arquivo/get/', 'GET', queryGet, (apiSuccess) => {
          // ADICIONA OS VALORES NO VETOR
          for (var index in apiSuccess.lot) {
            switch (apiSuccess.lot[index].code) {
              case '200':
                retornos.push(apiSuccess.lot[index].data)
                break

              default:
                this.$store.state.msgWarn('API [' + apiSuccess.lot[index].code + ']: ' + apiSuccess.lot[index].message, 'danger')
                break
            }
          }

          // FAZ A QUEBRA O VALOR RECEBIDO E CHAMA A FUNÇÃO PARA BUSCAR
          this.armArquivosRecebeQrCodeBuscarThumbnail(tipo, ids, callback, qtde, ini, fim, retornos)
        }, this.armArquivoAnexarSetarStatusGeral)
      } else {
        callback(retornos)
      }
    },
    armArquivoAnexarReceberArquivo: function (event) {
      // INICIA A VARIAVEL PARA VERIFICAR SE RECEBEU ALGUM ARQUIVO
      var recebeu = false

      // ADICIONA O ARQUIVO RECEBIDO
      for (var indexF in event) {
        // INICIA A VARIAVEL
        var registro = null

        // VERIFICA SE O VALOR RECEBIDO É REFERENTE AO CAMPO ABERTO
        switch (this.cpntRefMod) {
          case 7:
            if (event[indexF].acl === 'public-read') {
              registro = event[indexF]
            }
            break

          case 9:
            if (event[indexF].id_financeiro === this.cpntRefId.toString()) {
              registro = event[indexF]
            }
            break

          case 10:
            if (event[indexF].id_pro_imagem === this.cpntRefId.toString()) {
              registro = event[indexF]
            }
            break

          case 12:
            if (event[indexF].cod_venda === this.cpntRefId.toString()) {
              registro = event[indexF]
            }
            break

          case 31:
            if (event[indexF].id_doc_fis_distribuir === this.cpntRefId.toString()) {
              registro = event[indexF]
            }
            break

          case 53:
            if (event[indexF].id_reg_atendimento === this.cpntRefId.toString()) {
              registro = event[indexF]
            }
            break
        }

        if ([ '', null, undefined ].indexOf(registro) === -1) {
          switch (registro.status) {
            case '1':
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              registro.time = new Date().getTime()

              // VERIFICA SE RECEBEU ALGUM THUMBNAIL
              if ([ '', null, undefined ].indexOf(registro.thumbnail_b64) !== -1) {
                registro.thumbnail_b64 = ''
              }
  
              // ADICIONA O ARQUIVO
              this.files[registro.id] = registro
              break

            // SE ELE FOI ENVIADO PARA LIXEIRA
            default:
              delete this.files[registro.id]
              break
          }

          // SETA QUE RECEBEU UM ARQUIVO
          recebeu = true
        }
      }

      if (recebeu === true) {
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.timeRecebe = new Date().getTime().toString() + '--' + Object.keys(this.arquivos)
  
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    },
    armArquivoAnexarApagarArquivo: function (id) {
      if (window.confirm('Deseja realmente enviar para a lixeira o arquivo selecionado?')) {
        // CRIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { j_id: [ id ] }

        // FAZ A COMUNICAÇÃO COM A API
        this.$store.state.comunicaAPI('/arm-arquivo/lixeira', 'DELETE', formData, (apiSuccess) => {
          // TRATA A MENSAGEM RECEBIDA
          this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

          if (apiSuccess.lot[0].code === '200') {
            // REMOVE O ID SOLICITADO
            delete this.files[id]

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          } else {
            this.armArquivoAnexarBuscarArquivo()
          }
        }, this.armArquivoAnexarSetarStatusGeral)
      } else {
        this.armArquivoAnexarBuscarArquivo()
      }
    },
    armArquivoAnexarCopiarArquivo: function (id) {
      if ([ '', null, undefined ].indexOf(this.files[id].link_download) !== -1) {
        this.armArquivosRecebeQrCodeBuscarThumbnail('link_download', [ this.files[id].id ], (registros) => {
          // SETA O LINK DE DOWNLOAD DO ARQUIVO
          this.files[id].link_download = registros[0].link_download
          
          // CHAMA A FUNÇÃO PARA REINICIAR O PROCESSO
          this.armArquivoAnexarCopiarArquivo(id)
        })
      } else {
        this.$store.commit('FUN_COPIAR_VALOR', { valor: this.files[id].link_download, mensagem: 'Link do arquivo copiado para área de transferência.' })
      }
    }
  }
}
</script>
